/** The hook every consumer of a loaded GLB reads it through. */
import { useResource } from './useResource.js';
/**
 * The GLB at `path`, a clone for this consumer once loaded. No path requests nothing.
 *
 * @canonical A GLB for one consumer
 */
export function useGlb(path) {
    return useResource(path ?? '', 'glb');
}
//# sourceMappingURL=useGlb.js.map